<script>
import FormsModel from '@/components/forms/model'
import Loader from '../widgets/loader'
import Alert from '@/components/alert'

export default {
  components: {
    Loader,
    Alert
  },
  props: {
    cardTitle: String,
    loading: {type: Boolean, default: false},
    updating: {type: Boolean, default: false},
    deleting: {type: Boolean, default: false},
    resourceRoute: String,
    modelVariable: String,
    form: {
      type: Object, default: function () {
        return FormsModel
      }
    },
    formProps: {
      type: Object, default: function () {
        return {}
      }
    },
    formListeners: {
      type: Object, default: function () {
        return {}
      }
    },
    errors: {
      type: Object, default: function () {
        return {}
      }
    },
    modelKey: {type: String, default: 'id'},
    cardAttrs: {
      type: Object, default() {
        return {}
      }
    },
    denyBack: {type: Boolean, default: false},
    denyDelete: {type: Boolean, default: false},
    denyUpdate: {type: Boolean, default: false},
    value: {
      type: Object, default() {
        return {}
      }
    },
    alerts: {type: Array, default: () => []}
  },
  data() {
    return {
      model: this.value,
      isValid: true
    }
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },
  methods: {
    handleUpdate() {
      if (!('validateAll' in this.$refs.form)) return;
      this.$refs.form.validateAll().then((isValid) => {
        if (isValid) this.$nextTick(() => {
          this.$emit('update-click', this.model)
        })
      })
    },
    handleBack(event) {
      this.$emit('back-click', event)
    }
  }
}
</script>

<template>
  <div>
    <div class="row">
      <template v-for="(alert, index) in alerts">
        <div class="col-12 form-row" :key="index">
          <div class="col-md-8"></div>
          <div class="col">
            <Alert v-bind="alert"></Alert>
          </div>
        </div>
      </template>
    </div>
    <b-card v-bind="cardAttrs" :title="undefined" :sub-title="undefined">
      <b-card-title title-tag="div" class="clearfix">
        <slot name="card-header">
          <b-card-title>{{ cardAttrs.title || `${$t('Edit')} ${cardTitle || lodash.startCase($t(resourceRoute + '.singular'))}` }}</b-card-title>
          <b-card-sub-title v-if="cardAttrs.subTitle">{{ cardAttrs.subTitle }}</b-card-sub-title>
        </slot>
      </b-card-title>
      <slot>
        <Loader :loading="loading" no-axios>
          <component
            :is="form"
            v-bind="formProps"
            v-on="formListeners"
            v-model="model"
            :is-valid.sync="isValid"
            :errors="errors"
            @update:errors="$emit('update:errors', $event)"
            @model-changed="$emit('model-changed',$event)"
            ref="form"
          >
          </component>
        </Loader>
      </slot>
      <slot name="card-footer" v-bind="{ loading, updating, deleting, denyBack, handleUpdate, handleBack }">
        <div class="row">
          <div class="col-12 d-flex flex-row-reverse justify-content-start flex-wrap">
            <b-button :disabled="updating || deleting" v-if="!denyUpdate" class="ms-2" native-type="submit" variant="primary" @click="handleUpdate">
              <i v-if="updating" class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              {{ $t('Update') }}
            </b-button>
            <b-button :disabled="updating || deleting" v-if="!denyDelete && !value['_denyDelete']" class="ms-2" native-type="submit" variant="outline-danger" @click="$emit('delete-click')">
              <i v-if="deleting" class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              {{ $t('Delete') }}
            </b-button>
            <b-button class="ms-2" v-if="!denyBack" variant="link" @click="handleBack">
              {{ $t('Back') }}
            </b-button>
          </div>
        </div>
      </slot>
    </b-card>
  </div>
</template>
